module.exports = __webpack_public_path__ + "static/media/ico-alert-warning.c4e84eff.svg";